import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

/**
 * @param {boolean} isLike
 * @param {string} id
 * @param {string} url
 * @param {object} values
 * @returns {Promise<{responseBody: *, status: number}>}
 */
const sendFeedback = (isLike, id, url, values) => {
  const requestMethod = getAuthorizationToken()
    ? authorizedFetch
    : unauthorizedFetch;

  let message = {};

  if (values) {
    message = {
      comment: values?.message || '',
      email: values?.email || '',
    };
  }

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.POST,
    path: '/api/v1/wiki_how/reactions',
    body: {
      article: {
        uuid: id,
        url: url,
      },
      reaction: {
        is_like: isLike,
        ...message,
      },
    },
  });
};

export default sendFeedback;
